export const DigitalMarketingData = [
  {
    icon:"bi:stars",
    title:'MEDIA BUYING',
    titleAR:'الاعلانات الممولة',
    disc:"We plan and manage strategic ad placements across digital platforms to maximize reach, visibility, and ROI.",
    discAR:"نقوم بالتخطيط وإدارة إعلانات استراتيجية عبر المنصات الرقمية لزيادة الوصول، وتعزيز الظهور، وتحقيق أعلى عائد على الاستثمار.",
    link:'/media-buying-page'
  },
  {
    icon:"ph:tree-view-fill" ,
    title:'INFLUENCER MARKETING',
    titleAR:'التسويق عبر المؤثرين',
    discAR:'نربط علامتك التجارية بـ الأصوات والمجتمعات المناسبة، لنخلق شراكات حقيقية تبني الثقة وتزيد من التفاعل.',
    disc:"We connect your brand with the right voices and communities, creating authentic partnerships that inspire trust and engagement.",
    link:'/influencer-marketing-page'
  },
  {
    icon:"iconoir:message-text",
    title:'SOCIAL MEDIA',
    titleAR:'اداره منصات التواصل الاجتماع',
    disc:"From content creation to campaign management, we build social media strategies that grow your audience and strengthen your brand presence.",
    discAR:"من إنشاء المحتوى إلى إدارة الحملات، نقوم ببناء استراتيجيات سوشيال ميديا تساعد على توسيع جمهورك وتعزيز حضور علامتك التجارية.",
    link:'/social-media-page'
  },
  {
    icon:"system-uicons:clipboard-notes" ,
    title:'SEO',
    titleAR:' محركات البحث',
    disc:"Our SEO solutions boost your search engine visibility, bringing organic traffic, higher rankings, and long-term growth.",
    discAR:"حلول الـ SEO لدينا تعزز من ظهورك في محركات البحث، وتجذب زيارات طبيعية  (Organic Traffic)، وتمنحك ترتيباً أعلى ونمواً طويل المدى لعلامتك التجارية.",
    link:'/seo-services-page'
  }
]